import React from 'react';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { resourceUrl } from '../api';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import NavLink from '../controls/NavLink';
import IconButton from '@material-ui/core/IconButton';
import PersonIcon from '@material-ui/icons/Person';
import Popover from '@material-ui/core/Popover';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import initials from 'initials';
import { withAuthenticationContext } from '../Authenticate';
import Button from '@material-ui/core/Button';
import NavDrawer from './NavDrawer';
import Hidden from '@material-ui/core/Hidden';
import MenuIcon from '@material-ui/icons/Menu';

const styles = () => ({
    spacer: {
        flexGrow: 1,
    },
    logo: {
        marginTop: 5,
        marginRight: 20,
    },
    profileActions: {
        justifyContent: 'flex-end',
    },
});

class NavBar extends React.Component {
    state = {
        profileMenuAnchor: undefined,
        drawer: false,
    };

    openProfileMenu = (evt) => {
        this.setState({ profileMenuAnchor: evt.currentTarget });
    };

    closeProfileMenu = () => {
        this.setState({ profileMenuAnchor: undefined });
    };

    showDrawer = () => {
        this.setState({ drawer: true });
    };

    hideDrawer = () => {
        this.setState({ drawer: false });
    };

    render() {
        const logo = resourceUrl('siteInfo/logo');

        return (
            <React.Fragment>
                <AppBar position="fixed" color="default">
                    <Toolbar>
                        {this.props.location.pathname === '/' && (
                            <Hidden mdUp>
                                <IconButton onClick={this.showDrawer} title="Open application menu">
                                    <MenuIcon />
                                </IconButton>
                            </Hidden>
                        )}
                        <NavLink to="/" className={this.props.classes.logo}>
                            <img src={logo} alt={this.props.appTitle} />
                        </NavLink>
                        <div className={this.props.classes.spacer} />
                        <IconButton aria-label="Profile Menu" color="inherit" onClick={this.openProfileMenu}>
                            <PersonIcon fontSize="large" />
                        </IconButton>
                        <Popover
                            open={!!this.state.profileMenuAnchor}
                            onClose={this.closeProfileMenu}
                            anchorEl={this.state.profileMenuAnchor}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        >
                            <Card>
                                <CardHeader
                                    avatar={<Avatar>{initials(this.props.account.name)}</Avatar>}
                                    title={this.props.account.name}
                                />
                                <CardActions className={this.props.classes.profileActions}>
                                    <Button size="small" color="primary" onClick={this.props.logout}>
                                        Sign out
                                    </Button>
                                </CardActions>
                            </Card>
                        </Popover>
                    </Toolbar>
                </AppBar>
                {this.props.location.pathname === '/' && (
                    <NavDrawer
                        drawer={this.state.drawer}
                        hideDrawer={this.hideDrawer}
                        featureFlags={this.props.appFeatures}
                        userProfile={this.props.userProfile}
                    />
                )}
            </React.Fragment>
        );
    }
}

export default compose(withAuthenticationContext, withStyles(styles))(NavBar);
